import React, { useCallback, useState } from 'react'
import { GestureResponderEvent } from 'react-native'

import { Button, Pressable } from '@zet/design-system'
import TileTag from '@zet/design-system/tileTag/TileTag'
import { useUserContext } from '@zet/feature-user/api/user/hooks'
import {
  BUTTON_TYPE,
  INTENT,
  INTENT_MAPPING,
  USER_PROFILE_TYPE,
} from '@zet/utils/Constants'
import { styled } from 'nativewind'

import { IntentTriggerBottomSheet } from '../bottomSheets/IntentTriggerBottomSheet'

type IPressable = React.ComponentProps<typeof Pressable> & {
  type?: string
  name: string
}

function PressableWithIntent({
  type = BUTTON_TYPE.PRESSABLE,
  name,
  onPress,
  ...restProps
}: IPressable) {
  const { data: zetUser } = useUserContext()
  const [showBottomSheet, setShowBottomSheet] = useState(false)
  const intent =
    INTENT_MAPPING[name as keyof typeof INTENT_MAPPING] ?? undefined

  const checkIfUserCanProceed = () => {
    if (
      intent === INTENT.HIGH &&
      zetUser?.profileType === USER_PROFILE_TYPE.GUEST
    ) {
      setShowBottomSheet(true)
      return false
    } else if (
      intent === INTENT.LOW &&
      zetUser?.profileType === USER_PROFILE_TYPE.GUEST
    ) {
      setShowBottomSheet(true)
      return false
    }
    return true
  }

  const handleOnPress = useCallback(
    (args: GestureResponderEvent) => {
      if (checkIfUserCanProceed() && onPress) {
        onPress(args)
      }
    },
    [onPress]
  )

  const renderButton = () => {
    if (type === BUTTON_TYPE.BUTTON) {
      return <Button onPress={handleOnPress} {...restProps} />
    } else if (type === BUTTON_TYPE.TILE_TAG) {
      return <TileTag onPress={handleOnPress} {...restProps} />
    }
    return <Pressable onPress={handleOnPress} {...restProps} />
  }

  return (
    <>
      {renderButton()}
      <IntentTriggerBottomSheet
        isVisible={showBottomSheet}
        intent={intent}
        setIsVisible={setShowBottomSheet}
        handleOnPress={onPress}
      />
    </>
  )
}

const _Pressable = React.memo(styled(PressableWithIntent))

export { _Pressable as PressableWithIntent }
